export class VCreateUserModel {

  email: string
  password: string
  firstname: string
  lastname: string;
  cellphone: string
  landline: string
  fk_user_role: number // 1 /** Tenant | Locataire */ | 5 /** Owner | Popriétaire */
  civility: 1 /** Mr (M.) */ | 2/** Mrs (Mme) */
  block_id: number;
  /**
   *
   */
  constructor(partial: Partial<VCreateUserModel> = {}) {
    this.email = partial.email || '';
    this.password = partial.password || '';
    this.firstname = partial.firstname || '';
    this.lastname = partial.lastname || '';
    this.cellphone = partial.cellphone || '';
    this.landline = partial.landline || '';
    this.fk_user_role = partial.fk_user_role || 1;
    this.civility = partial.civility || 1;
    this.block_id = partial.block_id;
  }
}



// WEBPACK FOOTER //
// ./src/models/user/user-sign-up.model.ts